"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconPerson', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M5.57432 7.02311C4.97756 7.28048 4.38189 7.64203 3.83564 8.12759C2.47639 9.33581 1.5 11.2434 1.5 14C1.5 14.5523 1.94772 15 2.5 15L13.5 15C14.0523 15 14.5 14.5523 14.5 14C14.5 11.2434 13.5236 9.33581 12.1644 8.12759C11.6181 7.64203 11.0224 7.28048 10.4257 7.02311C11.0879 6.3863 11.5 5.49128 11.5 4.5C11.5 2.567 9.933 1 8 1C6.067 1 4.5 2.567 4.5 4.5C4.5 5.49128 4.9121 6.3863 5.57432 7.02311ZM12.4443 13H3.55567C3.74812 11.345 4.41476 10.2887 5.16436 9.62241C6.08689 8.80238 7.21762 8.5 8 8.5C8.78238 8.5 9.91311 8.80238 10.8356 9.62241C11.5852 10.2887 12.2519 11.345 12.4443 13ZM6.5 4.5C6.5 3.67157 7.17157 3 8 3C8.82843 3 9.5 3.67157 9.5 4.5C9.5 5.32843 8.82843 6 8 6C7.17157 6 6.5 5.32843 6.5 4.5Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M13.1815 8.68242C13.9961 7.86805 14.5 6.74287 14.5 5.5C14.5 3.01472 12.4853 1 10 1C7.51472 1 5.5 3.01472 5.5 5.5C5.5 6.74287 6.00386 7.86805 6.81846 8.68242C6.15924 8.97894 5.50044 9.39004 4.88823 9.94901C3.19501 11.495 2 14.0417 2 18C2 18.5523 2.44772 19 3 19H17C17.5523 19 18 18.5523 18 18C18 14.0417 16.805 11.495 15.1118 9.94901C14.4996 9.39004 13.8408 8.97894 13.1815 8.68242ZM7.5 5.5C7.5 4.11929 8.61929 3 10 3C11.3807 3 12.5 4.11929 12.5 5.5C12.5 6.88071 11.3807 8 10 8C8.61929 8 7.5 6.88071 7.5 5.5ZM10 10C8.92627 10 7.44225 10.3253 6.23677 11.426C5.17127 12.3988 4.20884 14.0824 4.02976 17H15.9702C15.7912 14.0824 14.8287 12.3988 13.7632 11.426C12.5577 10.3253 11.0737 10 10 10Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M15.416 10.8108C16.6857 9.80331 17.5 8.24675 17.5 6.5C17.5 3.46243 15.0376 1 12 1C8.96243 1 6.5 3.46243 6.5 6.5C6.5 8.24675 7.31428 9.80331 8.58395 10.8108C7.80811 11.1828 7.02656 11.7025 6.3019 12.409C4.40065 14.2627 3 17.2945 3 22C3 22.5523 3.44772 23 4 23H20C20.5523 23 21 22.5523 21 22C21 17.2945 19.5993 14.2627 17.6981 12.409C16.9734 11.7025 16.1919 11.1828 15.416 10.8108ZM8.5 6.5C8.5 4.567 10.067 3 12 3C13.933 3 15.5 4.567 15.5 6.5C15.5 8.433 13.933 10 12 10C10.067 10 8.5 8.433 8.5 6.5ZM12 12C10.8864 12 9.15053 12.4249 7.6981 13.841C6.38106 15.1251 5.20447 17.3158 5.02394 21H18.9761C18.7955 17.3158 17.6189 15.1251 16.3019 13.841C14.8495 12.4249 13.1136 12 12 12Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M11.0983 13.9973C9.96552 14.4691 8.82458 15.1361 7.76647 16.055C5.0064 18.4519 3 22.3972 3 28.5C3 29.3284 3.67157 30 4.5 30L27.5 30C28.3284 30 29 29.3284 29 28.5C29 22.3972 26.9936 18.4519 24.2335 16.055C23.1754 15.1361 22.0345 14.4691 20.9017 13.9973C22.1967 12.727 23 10.9573 23 9C23 5.13401 19.866 2 16 2C12.134 2 9 5.13401 9 9C9 10.9573 9.80334 12.727 11.0983 13.9973ZM25.9525 27H6.0475C6.3393 22.5248 7.93591 19.8811 9.73353 18.3201C11.7727 16.5492 14.2682 16 16 16C17.7318 16 20.2273 16.5492 22.2665 18.3201C24.0641 19.8811 25.6607 22.5248 25.9525 27ZM12 9C12 6.79086 13.7909 5 16 5C18.2091 5 20 6.79086 20 9C20 11.2091 18.2091 13 16 13C13.7909 13 12 11.2091 12 9Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;